module.exports = __webpack_public_path__ + "static/media/help.0d393fb0.svg";